import React from 'react';
import Styles from './ErrorMessage.css';
import Button from '../../widgets/Button/Button';
import { useSimuladorEnergiaSolarState } from '../../model/state';
import { SIMULATION_STEPS } from '../../model/simulation-steps';
import ContainerHome24 from '../../../../components/atoms/ContainerHome24';
import { useScroll } from '../../../../utils/useLayout';
import ModalComponent from '../../../../components/atoms/ModalComponent';
import { useEffect } from 'react';
import { devLog } from '../../../../utils/browser';
import StoreNotFoundPartial from '../StoreNotFound/StoreNotFoundPartial';

const WrapperComponent = ({ children, isModal = false, handleSetOpen }) => {
  if (isModal) {
    return (
      <ModalComponent
        hideCloseButton
        open
        setOpen={handleSetOpen}
        surfaceProps={{ className: 'modal-simulation-error' }}
      >
        {children}
      </ModalComponent>
    );
  }

  return <>{children}</>;
};

function ErrorMessage() {
  const { dynamicScrollTo } = useScroll();
  const { simulationStep, setSimulationStep, EventHandler, resetErrors } =
    useSimuladorEnergiaSolarState();

  const visible = simulationStep?.id === SIMULATION_STEPS.ERROR_GENERIC.id;
  const modal = visible && simulationStep?.modal;

  const isSessionExpired = simulationStep?.message === 'session-expired' && visible;

  const handleGoBack = () => {
    devLog('Handling go back from error message', simulationStep);

    if (isSessionExpired) {
      EventHandler.emit('reset');
      return;
    }

    if (!!simulationStep?.message) {
      if (resetErrors.some((m) => `${simulationStep?.message}`.toLowerCase().trim().includes(m))) {
        EventHandler.emit('reset');
        return;
      }
    }

    if (simulationStep?.event) {
      EventHandler.emit(simulationStep.event);
      return;
    }

    setSimulationStep(simulationStep.previousStep);
    dynamicScrollTo(simulationStep.scrollTo);
  };

  useEffect(() => {
    if (!visible || modal) return;

    dynamicScrollTo('top');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal, visible]);

  if (!visible) return null;

  if (simulationStep?.message === 'partial-store-not-partner') {
    return <StoreNotFoundPartial />;
  }

  return (
    <WrapperComponent isModal={modal} handleSetOpen={handleGoBack}>
      <div id="error-message" className="error-message">
        <ContainerHome24>
          <img
            className="error-icon"
            src="assets/simulador-energia-solar/jornada/ic-error.svg"
            alt=""
          />
          <h6 className="title">{simulationStep.title}</h6>
          {!isSessionExpired && <p className="description">{simulationStep.message}</p>}
          {isSessionExpired && <p className="description">Tempo de sessão expirada.</p>}

          <Button
            variant="white"
            onClick={(ev) => {
              ev.preventDefault();

              handleGoBack();
            }}
          >
            Tentar novamente
          </Button>
        </ContainerHome24>
      </div>

      <style jsx>{Styles}</style>
    </WrapperComponent>
  );
}

export default ErrorMessage;
